module.exports = __webpack_public_path__ + "static/assets/942f07a3136998b0f56e7f88d8e490ec.svg";